import React, { useCallback, useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { RootState } from "../../../reducers";
import { EditorInter } from "../../../reducers/editor";
import { syncEditorToolbarFromSelection } from "../../../lib/editorToolbarSync";
import {
  RestoreSelection,
  snapshotEditorSelectionIfInScreen,
} from "../../../lib/lib";

const color = [
  "#ff5c5c",
  "#ffb100",
  "#ffeb00",
  "#00db6e",
  "#16cbc4",
  "#3597ec",
  "#7435ec",
  "#ff65be",
  "#000000",
  "#adadad",
  "#ffffff",
];
function Ftstyle() {
  const dispatch = useDispatch();
  const store = useStore<RootState>();
  const [isOpen, setIsOpen] = useState(false);
  const nowState = useSelector<RootState, EditorInter>((state) => state.editor);
  const __syncToolbar = useCallback(() => {
    syncEditorToolbarFromSelection(
      dispatch,
      document.getElementById("screen"),
      store.getState().editor
    );
  }, [dispatch, store]);
  const __bold = useCallback(() => {
    RestoreSelection();
    document.execCommand("bold");
    __syncToolbar();
  }, [__syncToolbar]);
  const __line = useCallback(() => {
    RestoreSelection();
    document.execCommand("underline");
    __syncToolbar();
  }, [__syncToolbar]);
  const __color = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);
  const __changeColor = useCallback(
    (color: string) => {
      RestoreSelection();
      document.execCommand("foreColor", false, color);
      setIsOpen(false);
      __syncToolbar();
    },
    [__syncToolbar]
  );

  const dummy = [
    { img: "bold", type: "BOLD", callback: __bold },
    { img: "line", type: "LINE", callback: __line },
    { img: "color", type: "COLOR", callback: __color },
  ];
  return (
    <div className="ftstyle-wrapper">
      {dummy.map(({ img, type, callback }, idx) => {
        return (
          <React.Fragment key={idx}>
            <button
              className="style-btn"
              onMouseDown={(e) => {
                snapshotEditorSelectionIfInScreen();
                e.preventDefault();
              }}
              onClick={callback}
              style={{
                backgroundColor:
                  (type === "BOLD" && nowState.bold) ||
                  (type === "LINE" && nowState.underline)
                    ? "#d7a4f3"
                    : undefined,
              }}
            >
              <img src={`/assets/editor/${img}.svg`} alt="이미지" />
              {type === "COLOR" ? (
                <div
                  style={{
                    backgroundColor: nowState.color ? nowState.color : "black",
                  }}
                  className="color-box"
                />
              ) : undefined}
            </button>
            {type === "COLOR" ? (
              <div
                className="color-wrapper"
                style={{ opacity: isOpen ? 1 : 0 }}
              >
                {isOpen
                  ? color.map((item, idx) => {
                      return (
                        <button
                          onMouseDown={(e) => {
                            snapshotEditorSelectionIfInScreen();
                            e.preventDefault();
                          }}
                          onClick={() => {
                            __changeColor(item);
                          }}
                          className="color-box"
                          key={idx}
                          style={{
                            backgroundColor: item,
                            border:
                              item === "#ffffff" ? "solid 1px #dbdbdb" : 0,
                          }}
                        />
                      );
                    })
                  : undefined}
              </div>
            ) : undefined}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default Ftstyle;
